export enum AdditionalBenefitsTestID {
    Wrapper = 'additional_benefits_wrapper',
}

export enum AdditionalBenefitsModalTestID {
    Wrapper = 'additional_benefits_modal_wrapper',
    BenefitActive = 'additional_benefits_modal_benefit_active',
    BenefitNotActive = 'additional_benefits_modal_benefit_not_active',
    BenefitButton = 'additional_benefits_modal_benefit_button',
}

export enum BenefitBannerTestID {
    Container = 'BenefitBannerTestID.Container',
    Button = 'BenefitBannerTestID.Button',
}

export enum BenefitCardTestId {
    BenefitCard = 'BenefitCardTestId.BenefitCard',
    Image = 'BenefitCardTestId.Image',
}

export enum BenefitModalTestID {
    Modal = 'BenefitModalTestID.Modal',
    Button = 'BenefitModalTestID.Button',
    About = 'BenefitModalTestID.About',
    PhoneNumber = 'BenefitModalTestID.PhoneNumber',
}

export enum AllYourBenefitsPageTestId {
    Title = 'AllYourBenefitsPage.Title',
    Subtitle = 'AllYourBenefitsPage.Subtitle',
    FeaturedBenefitsSubtitle = 'AllYourBenefitsPage.FeaturedBenefitsSubtitle',
    ExploreYourBenefitsSubtitle = 'AllYourBenefitsPage.ExploreYourBenefitsSubtitle',
    TopicsList = 'AllYourBenefitsPage.TopicsList',
    CareNavigationBanner = 'AllYourBenefitsPage.CareNavigationBanner',
}

export enum BenefitPerCategoryPageTestId {
    Header = 'BenefitPerCategoryPageTestId.Header',
    Button = 'BenefitPerCategoryPageTestId.Button',
}

export enum CrisisModalTestID {
    Modal = 'CrisisModalTestID.Modal',
    InternationalSuicideHotlines = 'CrisisModalTestID.InternationalSuicideHotlines',
    InternationalHelplines = 'CrisisModalTestID.InternationalHelplines',
    VolunteerPhone = 'CrisisModalTestID.VolunteerPhone',
}

export enum ChooseYourSegmentPageTestID {
    Container = 'ChooseYourSegmentPageTestID.Container',
    SegmentInput = 'ChooseYourSegmentPageTestID.SegmentInput',
    Continue = 'ChooseYourSegmentPageTestID.Continue',
    BackHome = 'ChooseYourSegmentPageTestID.BackHome',
}
